module.exports = __webpack_public_path__ + "img/p9.7ff9b03a.png";